import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse} from "axios";
import {useToastStore} from "@/stores/toast";

let MAX_RETRIES = 3;
let loaderContainer = 'app';

interface AxiosConfig extends AxiosRequestConfig {
  retryCount?: number;
  loaderContainer?: string;
}
interface AxiosConfigCustom extends AxiosConfig {
  retryCount: number;
}
interface AxiosErrorCustom extends AxiosError {
  config: AxiosConfigCustom;
}

const onRequest = (config: AxiosConfig): AxiosRequestConfig => {
    if (config.loaderContainer) {
        loaderContainer = config.loaderContainer
    }
    window["SPSM"].addLoadingOverlay(loaderContainer)
    return config;
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
    if (document.querySelector(`#${loaderContainer} .loading-overlay`)){
        window["SPSM"].removeLoadingOverlay(loaderContainer);
    }
    return response;
}

const onResponseError = (error: AxiosErrorCustom): Promise<AxiosResponse<any> | AxiosErrorCustom> => {
    const toastStore = useToastStore();
    const retryCodes = [408, 502, 503, 504, 522, 524]

    error.config.retryCount = (error.config.retryCount || 0) + 1;
    const { config, message } = error;
    toastStore.errorMessage =  message;
    if (!config) {
        return Promise.reject(error);
    }
    // retry while Network timeout or Network Error
    if (message.includes("timeout") || message.includes("Network Error")|| retryCodes.includes(<number>error?.response?.status)) {
        if(error.config.retryCount < MAX_RETRIES) {
            const delayRetryRequest = new Promise((resolve) => {
                setTimeout(() => {
                resolve('');
                }, 300);
            });
            return delayRetryRequest.then(() => axios(config));
        }
        else {
            toastStore.addToast({message: message, toastType:"danger"});
        }
    }
    else if (error?.response?.status === 401) {
        toastStore.addToast({message: '401 Unauthorized', toastType:"danger"});
        window.location.href = '/login'
    }
    else if (error?.response?.status === 422) {
       let message = '';
       Object.entries(error.response.data as object).forEach( ([key, value])=> {
        message = message.concat(value + ';')
       });
       toastStore.addToast({message: message, toastType:"danger"});
    }
    else if (error?.response?.status === 500) {
        toastStore.addToast({ message: error.name === 'AxiosError' ? error.response.data as string: '500 Internal Error', toastType:"danger" });
    } else if (error?.response?.status === 302) {
        toastStore.addToast({message:message, toastType:"warning"});
    }
    window["SPSM"].removeLoadingOverlay(loaderContainer);
    return Promise.reject(error);
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
}